import { useLanguage } from "../../components/contexts/LanguageContext"; 
import translations from "../../components/translations";

function useTranslatedHeaders() {
  const { selectedLanguage } = useLanguage();

  const tableheaders = [
    {
      id: "organisationUnitId",
      label: translations[selectedLanguage].city,
      visible: false,
    },
    {
      id: "organisationUnit",
      label: translations[selectedLanguage].city,
      visible: true,
    },
    {
      id: "weather",
      label: translations[selectedLanguage].temperature,
      visible: true,
    },
    {
      id: "precipitation",
      label: translations[selectedLanguage].precipitation,
      visible: true,
    },
    {
      id: "relHumidity",
      label: translations[selectedLanguage].humidity,
      visible: true,
    },
    {
      id: "wind",
      label: translations[selectedLanguage].wind,
      visible: true,
    },
    {
      id: "sun",
      label: translations[selectedLanguage].sunriseSunset,
      visible: false,
    },
    {
      id: "moon",
      label: translations[selectedLanguage].moonriseMoonset,
      visible: false,
    },
  ];

  const data = [
    {
        "orgUnit": "Bairro da Coop",
        "icon": "sleet",
        "tmax": "33",
        "tmin": "23",
        "sunrise": "05:00",
        "sunset": "17:09",
        "moonrise": "---",
        "moonset": "00:09"
    },
    {
        "orgUnit": "Bairro do Areoporto",
        "icon": "sleet",
        "tmax": "30",
        "tmin": "15",
        "sunrise": "05:00",
        "sunset": "17:09",
        "moonrise": "---",
        "moonset": "00:09"
    },
];

  const table1 = {
    headers: [
      {
        id: "info",
        label: translations[selectedLanguage].info,
      },
      {
        id: "lastmonths",
        label: translations[selectedLanguage].lastmonths12,
      },
      {
        id: "allyears",
        label: translations[selectedLanguage].allyears,
      },
    ],
    rows: [
      {
        info: translations[selectedLanguage].hottestMonth,
        lastmonths: "janeiro",
        allyears: "fevereiro",
      },
      {
        info: translations[selectedLanguage].coldestMonth,
        lastmonths: "julho",
        allyears: "julho",
      },
      {
        info: translations[selectedLanguage].wettestMonth,
        lastmonths: "maio",
        allyears: "março",
      },
      {
        info: translations[selectedLanguage].windiestMonth,
        lastmonths: "setembro",
        allyears: "setembro",
      },
    ],
  };

  const table2 = {
    headers: [
      {
        id: "summary",
        label: translations[selectedLanguage].dailySummary12Months ,
      },
      {
        id: "max",
        label: translations[selectedLanguage].max,
      },
      {
        id: "avgr",
        label: translations[selectedLanguage].avgr,
      },
      {
        id: "min",
        label: translations[selectedLanguage].min,
      },
    ],
    rows: [
      {
        summary: translations[selectedLanguage].highTemp,
        max: 37,
        avgr: 28,
        min: 16,
      },
      {
        summary: translations[selectedLanguage].lowTemp,
        max: 28,
        avgr: 19,
        min: 10,
      },
      {
        summary: `${translations[selectedLanguage].precipitation} (mm)`,
        max: 155.21,
        avgr: 3.1,
        min: 0,
      },
      {
        summary: `${translations[selectedLanguage].wind} (km/h)`,
        max: 30.4,
        avgr: 15.04,
        min: 6.5,
      },
    ],
  };

  return { tableheaders, data, table1, table2 };
}

export default useTranslatedHeaders;
